<template
  ><div class="modal_wrap bottom_modal " :class="{ on: isOpen }">
    <div class="modal_inner" @click.self="$emit('close')">
      <div class="modal">
        <div class="send_more">
          <button @click.stop.prevent="openCamera()" v-if="false">
            <span class="i_send_camera"></span>카메라
          </button>
          <button @click.stop.prevent="openGallery()">
            <span class="i_send_new_image"></span>이미지
          </button>
          <button
            @click.stop.prevent="openMobileEstimateList(chatroom, 'ONLINE')"
            v-if="isCustomer && chatroom.mobileEstimateCnt > 0"
          >
            <span class="i_send_new_mobile_apply"></span>휴대폰 개통<br />신청서(비대면)
          </button>
          <button
            @click.stop.prevent="openMobileEstimateList(chatroom, 'VISIT')"
            v-if="isCustomer && chatroom.mobileEstimateCnt > 0"
          >
            <span class="i_send_new_send"></span>휴대폰 개통<br />신청서(매장방문)
          </button>
          <!--버튼 네개다 노출시 margin-top: 1.2rem 추가-->
          <button
            @click.stop.prevent="openInternetQuotationList()"
            style="word-break: keep-all;"
            :style="
              chatroom.mobileEstimateCnt > 0 && chatroom.icQuotationCnt > 0
                ? 'margin-top: 1.2rem'
                : 'margin-top: 0'
            "
            v-if="isCustomer && chatroom.icQuotationCnt > 0"
          >
            <span class="i_send_new_internet_join"></span>인터넷<br />가입신청서
          </button>
          <button v-if="isCustomer" @click.stop.prevent="reportStore()">
            <span class="i_send_new_report"></span>매장 신고하기
          </button>
          <!-- <button
            v-if="isCustomer"
            @click.stop.prevent="openEstimationListModal()"
          >
            <span class="i_send_new_request"></span>요청서 보내기
          </button> -->
          <!-- <button v-if="isCustomer" @click.stop.prevent="openPromiseModal()">
            <span class="i_send_new_promise"></span>방문약속
          </button> -->
          <!-- <button
            v-if="isCustomer && followed && !estimationAuto"
            @click.stop.prevent="requestEstimationAuto()"
          >
            <span class="i_send_new_print"></span>자동견적 받기
          </button> -->
          <button
            v-if="isCustomer && followed && estimationAuto"
            @click.stop.prevent="cancelEstimationAuto()"
          >
            <span class="i_send_new_cancel"></span>자동견적 취소
          </button>
          <!-- <button v-if="isCustomer" @click.stop.prevent="openNewBookModal()">
            <span class="i_send_new_book"></span>사전예약 신청
          </button> -->

          <button v-if="!isCustomer" @click.stop.prevent="openQuotation()">
            <span class="i_send_new_send"></span>휴대폰 견적서
          </button>

          <button v-if="!isCustomer" @click.stop.prevent="openInternetForm()">
            <span class="i_send_new_internet_join"></span>인터넷 견적서
          </button>

          <button
            v-if="!isCustomer"
            @click.stop.prevent="openChatMessageListModal()"
          >
            <span class="i_send_new_message"></span>자주쓰는 문구
          </button>
          <button v-if="!isCustomer" @click.stop.prevent="reportUser()">
            <span class="i_send_new_report"></span>고객 신고하기
          </button>

          <input
            ref="cameraFile"
            id="cameraFile"
            type="file"
            accept="image/*"
            capture="environment"
            @change="handleImageChange"
            v-show="false"
          />
          <input
            ref="imageFile"
            id="imageFile"
            type="file"
            accept="image/*"
            @change="handleImageChange"
            v-show="false"
          />
          <!-- webkitdirectory="true" 제외 처리 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  handleFile,
  transformCoordinate,
  dataURItoBlob,
} from '@common/lib/common/imgUtils';
import {
  mapActions as mapXeronoteActions,
  mapGetters as mapXeronoteGetters,
} from '@common/store/modules/xeronote';
import * as xeronoteTypes from '@common/store/modules/xeronote/types';
import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';
import {
  mapActions as mapEstimateActions,
  mapGetters as mapEstimateGetters,
  mapMutations as estimateMapMutations,
} from '@common/store/modules/estimate';
import * as estimateTypes from '@common/store/modules/estimate/types';
import * as estimateGetters from '@common/store/modules/estimate/getters';

export default {
  name: 'AttachmentModal',
  props: {
    chatroom: Object,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  created() {},
  computed: {
    ...shopMapGetters({
      shop: shopTypes.SHOP,
    }),
    ...mapEstimateGetters({
      autoEstimation: estimateTypes.AUTO_ESTIMATION,
      quotation: estimateTypes.QUOTATION,
    }),
    followed() {
      if (this.shop) {
        return this.shop.followed;
      }
      return false;
    },
    estimationAuto() {
      if (this.autoEstimation) {
        return true;
      }
      return false;
    },
    isCustomer() {
      return process.env.VUE_APP_APP_NAME === 'customer';
    },
  },
  methods: {
    ...mapEstimateActions([
      estimateTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS,
      estimateTypes.FETCH_LATELY_ESTIMATION,
      estimateTypes.ESTIMATION_MODEL_RESET_STATE,
    ]),
    ...estimateMapMutations([
      estimateTypes.SET_QUOTATION,
      estimateTypes.QUOTATION_RESET_STATE,
    ]),
    openCamera() {
      this.$refs.cameraFile.click();
    },
    openGallery() {
      this.$refs.imageFile.click();
    },
    reportStore() {
      this.$emit('reportStore');
    },
    reportUser() {
      this.$emit('reportUser');
    },
    openEstimationListModal() {
      this.$emit('openEstimationListModal');
    },
    openPromiseModal() {
      this.$emit('openPromiseModal', this.chatroom);
    },
    openNewBookModal() {
      this.$emit('openNewBookModal');
    },
    openChatMessageListModal() {
      this.$emit('openChatMessageListModal');
    },
    // requestEstimationAuto() {
    //   this[estimateTypes.ESTIMATION_MODEL_RESET_STATE]();
    //   this.$router.push({
    //     name: 'Estimation.AutoCreate',
    //     params: {
    //       uuid: this.chatroom.uuid,
    //       storeId: this.chatroom.store.id,
    //     },
    //   });
    // },
    cancelEstimationAuto() {
      this.$emit('cancelEstimationAuto');
    },
    async openQuotation() {
      this[estimateTypes.QUOTATION_RESET_STATE]();
      // 로컬 삭제
      localStorage.removeItem('mobileEstimate');
      localStorage.removeItem('mobileEstimatePlan');
      localStorage.removeItem('mobileService');
      localStorage.removeItem('mobileInsurance');
      const customer = this.chatroom.chatMembers.find(
        m => m.user.roles !== '21',
      );
      // const data = await this[estimateTypes.FETCH_LATELY_ESTIMATION]({
      //   userId: customer.userId,
      //   storeId: this.chatroom.store.id,
      // });
      // if (data) {
      //   this.quotation.estimateId.push(data.id);
      //   this.quotation.estimateSendView.push(data.sendView);
      // } else {
      //   this.quotation.estimateId.push(0);
      //   this.quotation.estimateSendView.push('');
      // }
      // this.quotation.userId.push(customer.userId);
      // this.quotation.storeName = this.chatroom.store.name;
      // this.quotation.isFromChat = true;

      // await this[estimateTypes.SET_QUOTATION](this.quotation);
      // this.$router.push({
      //   name: 'Estimation.SendQuotation',
      //   params: {
      //     uuid: this.chatroom.uuid,
      //     storeId: this.chatroom.store.id,
      //     customerId: customer.userId,
      //   },
      // });
      // 페이지 이동
      let name = 'Mobile.Create';
      this.$router.push({
        name,
        query: {
          id: 0,
          userId: customer.userId,
        },
      });
    },
    openInternetForm() {
      const customer = this.chatroom.chatMembers.find(
        m => m.user.roles !== '21',
      );
      console.log('this.chatroomthis.chatroomthis.chatroom==');
      console.log(this.chatroom);
      this.$router.push({
        name: 'InternetCommerce.Quotation',
        query: {
          uuid: this.chatroom.uuid,
          storeId: this.chatroom.store.id,
          userId: customer.userId,
          chatroomId: this.chatroom.id,
        },
      });
    },
    handleImageChange(e) {
      const maxWidth = 1024,
        quality = 0.92,
        enableCompress = true;

      const target = e.target || e.srcElement;
      const inputChangeFiles = target.files;
      if (inputChangeFiles.length > 0) {
        const file = inputChangeFiles[0];
        const doSquash = file.type === 'image/jpeg';
        return handleFile(
          file,
          {
            maxWidth,
            quality,
            enableCompress,
          },
          doSquash,
        ).then(blob => {
          const blobURL = URL.createObjectURL(blob);
          const fileItem = {
            url: blobURL,
            blob,
          };
          for (let key in file) {
            if (['slice', 'webkitRelativePath'].indexOf(key) === -1) {
              fileItem[key] = file[key];
            }
          }
          this.$emit('handleImageChange', fileItem);
        });
      }
    },
    openMobileEstimateList(chatroom, openType) {
      this.$emit('openMobileEstimateList', chatroom, openType);
    },
    openInternetQuotationList() {
      this.$emit('openInternetQuotationList');
    },
  },
};
</script>
